export class NumberUtil {
  public static getMaxAndMinValues(...sizes: number[]): { max: number; min: number } {
    if (!sizes.length) {
      throw new Error('Array must not be empty.');
    }

    let max: number = sizes[0];
    let min: number = sizes[0];

    for (const size of sizes) {
      if (size > max) {
        max = size;
      }

      if (size < min) {
        min = size;
      }
    }

    return { max, min };
  }
}
